import React from 'react';
import {Select,Icon, Radio, Input, Popover, Button, Tooltip, message, Card} from 'antd';
import {connect} from 'react-redux';
import Info from '../Detail/Info.js';
import AjaxAction from '../../actions/AjaxAction.js';
import actions from '../../actions/index.js';
import func from '../../util/func.js';
import './index.scss';

const RadioGroup = Radio.Group;

class BillInfoList extends React.Component {
    static defaultProps = {

    };

    constructor(props){
        super(props);

        this.state = {
            list:[],
            consumerid:props.consumerid || 0,
            value:props.value || 0,
            edit:false,
            info:{}
        };
    }

    componentDidMount() {
        this.fetchList();
    }

    componentWillReceiveProps(nextProps) {
        var update = {};
        if(nextProps.consuemrid != this.state.consumerid) {
            update.consumerid = nextProps.consumerid;
        }
        if(nextProps.value != this.state.value) {
            update.value = nextProps.value;
        }
        if(Object.keys(update).length) {
            this.setState(update, this.fetchList);
        }
    }

    fetchList() {
        let {dispatch} = this.props;
        let {consumerid} = this.state;
        if(consumerid) {
            dispatch(AjaxAction.billInfoList({
                consumerid
            })).then(res=>{
                this.setState({
                    list:res
                })
            });
        }
    }

    trash(id) {
        let {dispatch} = this.props;
        dispatch(AjaxAction.billInfoTrash(id)).then(res=>{
            if(res && res.success) {
                message.success('发票抬头作废成功');
                this.fetchList();
            }else {
                message.error('发票抬头作废失败');
            }
        });
    }

    setKeyValue = (key, value)=>{
        this.setState({
            info:{
                ...this.state.info,
                [key]:value
            }
        });
    }

    createBillInfo = ()=>{
        let {dispatch} = this.props;
        let {info, consumerid} = this.state;
        info = Object.assign({}, info);

        if(!info.title) {
            message.error('公司抬头为必填项');
            return;
        }
        if(!info.identify) {
            message.error('统一税号为必填项');
            return;
        }

        dispatch(AjaxAction.billInfoAdd({
            consumerid,
            ...info
        })).then(res=>{
            if(res && res.success) {
                message.success('添加成功');
                this.setState({
                    edit:false,
                    info:{}
                }, this.fetchList);
            }else {
                message.error('添加失败');
            }
        });
    }

    onChange = (value)=>{
        let {onChange} = this.props;
        onChange && onChange(value);
    }

    setClipboard(target) {
        let {navigator} = window;
        let {clipboard} = navigator;

        if(clipboard) {
            clipboard.writeText(`抬头：${target.title}
税号：${target.identify}
银行：${target.bank}
账号：${target.account}
地址：${target.address}
电话：${target.phone}
`).then(res=>{
                message.success('复制成功');
            }).catch(err=>{
                message.error('复制失败，请手动选择');
            });
        }
    }

    render() {
        let {value, list, edit, info} = this.state;
        let target = (list || []).filter(it=>it.id   === value);
        if(target && target.length) {
            target = target[0];
        }
        console.log(list);
        return <div className="billinfo">
            {target && target.title ? <div className="dp-f a-c j-c" style={{marginBottom:10,width:300, flexDirection:'row'}}>
                <Input value={(target.title||"") + ' ' + (target.identify||"")} disabled={true} style={{width:240}} />
                <a style={{marginLeft:10}} onClick={this.setClipboard.bind(this, target)} >复制</a>
            </div> : null}
            <RadioGroup onChange={this.onChange} value={value}>
                {list.map(it=>{
                    return (it.id == value || it.trash == 0) ? <Radio style={{display:'block'}} key={it.id} value={it.id}>
                        <Tooltip placement="topLeft" title={<div>
                            <p>抬头：{it.title}</p>
                            <p>税号：{it.identify}</p>
                            <p>银行：{it.bank}</p>
                            <p>账号：{it.account}</p>
                            <p>地址：{it.address}</p>
                            <p>电话：{it.phone}</p>
                        </div>}>
                            <span>{it.title} {it.identify}</span>
                            {value != it.id ? <span style={{marginLeft:20}}><a  onClick={()=>this.trash(it.id)}>作废</a></span> : null}
                        </Tooltip>
                    </Radio> : null
                })}
            </RadioGroup>
            {edit ? <Card title="请填写开票信息" extra={<div><Button style={{marginRight:10}} onClick={()=>{this.setState({edit:false,info:{}})}}>取消</Button><Button type="primary" onClick={this.createBillInfo}>保存</Button></div>}>
                <div className="">
                    <div className="dp-f a-c j-c"><Info label="公司抬头" required value={info.title} onChange={this.setKeyValue.bind(this, 'title')} /></div>
                    <div className="dp-f a-c j-c"><Info label="统一税号" required value={info.identify} onChange={this.setKeyValue.bind(this, 'identify')} /></div>
                    <div className="dp-f a-c j-c"><Info label="开户银行" value={info.bank} onChange={this.setKeyValue.bind(this, 'bank')} /></div>
                    <div className="dp-f a-c j-c"><Info label="银行账号" value={info.account} onChange={this.setKeyValue.bind(this, 'account')} /></div>
                    <div className="dp-f a-c j-c"><Info label="联系地址" value={info.address} onChange={this.setKeyValue.bind(this, 'address')} /></div>
                    <div className="dp-f a-c j-c"><Info label="联系电话" value={info.phone} onChange={this.setKeyValue.bind(this, 'phone')} /></div>
                </div>
            </Card> : <div><a  onClick={()=>this.setState({edit:true, info:{}})}>+新增抬头</a></div>}
        </div>;
    }
};

export default connect((state) => ({
}))(BillInfoList);



// WEBPACK FOOTER //
// ./src/components/Select/BillInfoList.js